/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementFigureIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementFigureIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <g>
            <path d="M11 12H5V11H11V12Z" fill="currentColor" />
            <path
              d="M5 4C5.55228 4 6 4.44772 6 5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 2C13.5523 2 14 2.44772 14 3V13C14 13.5177 13.6067 13.9438 13.1025 13.9951L13 14H3L2.89746 13.9951C2.42703 13.9472 2.05278 13.573 2.00488 13.1025L2 13V3C2 2.44772 2.44772 2 3 2H13ZM3 10V13H13V10H3ZM3 9H4.79297L7.43945 6.35352C8.02522 5.76783 8.97478 5.76783 9.56055 6.35352L12.207 9H13V3H3V9ZM8.85352 7.06055C8.65827 6.86539 8.34173 6.86538 8.14648 7.06055L6.20703 9H10.793L8.85352 7.06055Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementFigureIcon.tags = [
  'caption',
  'figure',
  'container',
  'div',
  'tag image',
  'picture',
  'photo',
  'gallery',
  'landscape',
  'photo_album',
  'thumbnail',
];

ElementFigureIcon.category = 'Navigator';

ElementFigureIcon.iconSize = 16;
